<template>
  <div v-loading="loading" class="app-container" style="width: 100%; height: 100vh; display: flex">
    <iframe :src="iframeUrl" frameborder="0" style="flex: 1" />
  </div>
</template>

<script>
import { getDashboardParams } from '@/api/finance/dataDheet';

export default {
  name: '',

  props: {
    type: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      iframeUrl: '',
      loading: false
    };
  },

  activated() {
    this.init();
  },
  created() {
    this.init();
  },

  methods: {
    init() {
      this.loading = true;
      getDashboardParams(this.type).then((res) => {
        if (res.code === 200 && res.data) {
          const { authType, pageId, projectId, scope, token } = res.data;

          this.iframeUrl = `https://sharegray.tcbi.qq.com/page/embed?authType=${authType}&pageId=${pageId}&projectId=${projectId}&scope=${scope}&token=${token}`;
        }
      }).catch((err) => {
        console.error(err);
      }).finally(() => {
        this.loading = false;
      });
    }
  }

};
</script>

<style lang="scss" scoped>
</style>
